import React from 'react';

import { AppStateContext } from 'src/contexts/app-state-provider.context';
import Helmet from 'react-helmet';
import SSRPage from 'src/components/ssr-page';
import PatientPage from 'src/pages/home/index';

const isBrowser = typeof window !== 'undefined';

export default class LoginPage extends React.Component {
  static contextType = AppStateContext;
  componentDidMount() {
    // GA4 is now initialized in layout component
    this.context.setSection('home');
    this.context.setPage('home');
  }

  render() {
    if (!isBrowser) {
      return <SSRPage noindexMeta={false} />;
    }

    return (
      <>
        <AppStateContext.Consumer>
          {({ _language }) => (
            <Helmet
              title='Welcome | VABYSMO'
              meta={[
                {
                  name: 'description',
                  content:'You have been prescribed VABYSMO. Look at this website to learn more about your medicine and other useful information.'
                },
                {
                 'http-equiv' : 'Content-Security-Policy',
                  content:"script-src 'self' 'unsafe-inline' 'unsafe-eval' *.roche.com *.roche.net *.gene.com snap.licdn.com cdn.walkme.com apis.google.com tpc.googlesyndication.com api.html5media.info workdevapp.com cdn-js.net gdata.youtube.com twitter.com geolocation.onetrust.com api.flickr.com graph.facebook.com sharecdn.social9.com maps.googleapis.com use.typekit.com use.typekit.net munchkin.marketo.net img.en25.com w.likebtn.com cdn.mathjax.org sadmin.brightcove.com cdnjs.cloudflare.com releases.flowplayer.org script.crazyegg.com wi.likebtn.com pepperglobal.com analytics.twitter.com cdn.blueconic.net connect.facebook.net fullstory.com script.hotjar.com gnntch.blueconic.net rules.quantcount.com secure.quantserve.com static.hotjar.com www.youtube.com www.googletagmanager.com www.google-analytics.com google-analytics.com *.gstatic.com static.ads-twitter.com sjs.bizographics.com *.linkedin.com www.google.com w.soundcloud.com s.ytimg.com *.cloudflareaccess.com *.salesforceliveagent.com https://*.roche.com:8080 https://cdnjs.org https://service.force.com/* cdn.cookielaw.org static.cloudflareinsights.com googleads.g.doubleclick.net 7232514.collect.igodigital.com https://s2.adform.net; img-src 'self' data: https://asia.adform.net; connect-src 'self' https://www.google-analytics.com https://region1.google-analytics.com https://asia.adform.net https://cdn.cookielaw.org;"
                }
              ]}
            >
              
              <html lang='en' />
              <link rel='canonical' href='https://vabysmo.co.nz/' />
              <script
                src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
                data-language="en-NZ"
                type="text/javascript"
                charset="UTF-8"
                data-domain-script="5d0b62db-363a-48e2-9d72-c09d5036150b" >

              </script>
              <script type="text/javascript">{`function OptanonWrapper() {}`}</script>

              <body />
            </Helmet>
          )}
        </AppStateContext.Consumer>
        <PatientPage />
      </>
    );
  }
}
